const fontSize = Object.freeze({
  heading: '17px',
  subHeadeing: '15px',
  formLabel: '13px',
  tableCellFontSm: '12px',
});

export default fontSize;
